<template>
  <div class="home1 full-height">
    <!-- default-banner linear-main3  -->
    <div
      style="height: 224px"
      class="bg-main"
    >
      <!-- <ld-header v-if="isGat()"
        transparent
        whitecha
        @click-left="back"
      >
        <img
          slot="left"
          class="custom-back"
          src="~Assets/images/back.png"
        >
      </ld-header> -->
      <ld-header v-if="isDjkk()" transparent whitecha @click-left="back" >
        <img slot="left" class="custom-back" src="~Assets/images/back.png">
      </ld-header>
      <van-swipe
        :autoplay="5000"
        height="224"
      >
        <van-swipe-item
          v-for="(advertise, index_) in images"
          :key="index_"
        >
          <van-image
            lazy-load
            :src="advertise.pictureUrl"
            @click="goAdvertiseLink(advertise.advertiseLink)"
            class="full-width"
          />
        </van-swipe-item>
      </van-swipe>
      <ld-statusbar />
      &nbsp;
    </div>
    <div
      class="full-width"
      style="position: absolute; top: 50px; padding: 0px 10px;pointer-events: none;"
    >
      <van-row
        class="white list"
        type="flex"
        align="center"
      >
        <van-col
          span="18"
          class="logo font18"
        >
          <!-- {{ loginConfig.pageName }} -->
        </van-col>
        <van-col span="2">
          <!-- <div
            v-if="loginConfig.by4 == 'QHHK'"
            class="inline-block white pointerEvents"
            @click="$emit('changeHome')"
          >
            <span
              style="
                display: inline-block;
                padding: 0px 2px;
                border: 1px solid #fff;
                border-radius: 3px;
              "
            >
              <van-icon
                name="exchange"
                class="font18"
              />
            </span>
            <div class="font12">
              版本
            </div>
          </div> -->
          &nbsp;
        </van-col>
        <van-col span="4">
          <div
            class="server text-center pointerEvents"
            @click="$router.push({ path: '/service' })"
          >
            <van-icon
              class="font22" :class="{'longLv-icon':isLongLv}"
              name="service"
            />
            <div class="font12" :class="{'longLv-text':isLongLv}">
              {{ $t("A022", "专属客服") }}
              {{ isLongLv ? '包车客服' : '' }}
            </div>
          </div>
        </van-col>
      </van-row>

      <div class="defaulthomewrapper">
        <mescroll-vue
          ref="mescroll"
          :down="{ use: false }"
        >
          <div class="white box">
            <div class="list font18">
              {{ getTimeState() }}好
              <span v-if="userInfo.empInf || (userInfo.empInfo&&userInfo.empInfo.empName)">
                ，
              </span>
              {{
                userInfo.empInfo && userInfo.empInfo.empName
              }}
            </div>
            <div class="list" v-if="userInfo.vipCorp || (userInfo.vipCorp&&userInfo.vipCorp.shortname)">
              欢迎您进入{{ userInfo.vipCorp && userInfo.vipCorp.shortname }}
            </div>
          </div>
          <!-- pointerEvents:auto :处理banner图覆盖问题 -->
          <div class="pointerEvents">
            <!-- Menu -->
            <div class="list round-md">
              <van-cell
                class="round-md bg-image"
                v-show="orderList.length == 0"
                style="height: 110px"
                center
              >
                <div style="padding: 10px">
                  <div class="font20 font-bold green">
                    暂无行程
                  </div>
                  <div class="gray">
                    暂无日程，请前往机票模块预订
                  </div>
                </div>
                <div slot="right-icon">
                  <img
                    src="~Components/Dynamic/default/images/schedule-empty.png"
                    style="width: 136px; margin-top: 29px"
                  >
                </div>
              </van-cell>
              <van-swipe
                class="shadow vanSwipe"
                :autoplay="0"
                height="110"
                v-show="orderList.length"
              >
                <van-swipe-item
                  v-for="(item, index) in orderList"
                  :key="index"
                  @click="$router.push({ path: '/schedule' })"
                >
                  <SchedulePanel
                    :data="item"
                    :order-type="item.orderType"
                  />
                </van-swipe-item>
              </van-swipe>
            </div>

            <!--  -->
            <div
              class="list"
              v-if="loginNotices && loginNotices.length"
            >
              <van-notice-bar
                class="full-width round-md shadow"
                background="#ffffff"
                mode="link"
                color="#707070"
                @click="$router.push({ path: '/noticeList' })"
              >
                <van-image
                  width="24"
                  style="padding-right: 6px"
                  slot="left-icon"
                  :src="bullhorn_icon"
                />
                <span
                  v-for="notice in loginNotices"
                  :key="notice.id"
                >
                  {{ notice.content }}
                </span>
              </van-notice-bar>
              <van-dialog v-model="showLogonDialog" :title="loginNotices[0].tzTitle">
                <div class="pad-16 font12" style="color: #707070" v-html="loginNotices[0].content"/>
              </van-dialog>
            </div>

            <!-- :class="[item.openDiasble ? 'menu-disabled' : '']" -->
            <van-row
              type="flex"
              gutter="10"
            >
              <van-col
                span="12"
                v-for="tab in menuListnew"
                :key="tab.link"
                class="list"
                v-if="tab.openDiasble"
              >
                <div class="container bg-white round-md shadow">
                  <van-cell @click="to(tab)">
                    <van-image
                      v-lazy
                      width="42"
                      height="42"
                      :src="tab.img"
                    />
                    <div class="font16 font-md">
                      {{ $t(tab.title) }}
                    </div>
                    <div class="gray">
                      {{ tab.label }}
                    </div>
                  </van-cell>
                </div>
              </van-col>
            </van-row>

            <!--  -->
            <div
              class="list"
              v-show="modularnew"
            >
              <van-cell class="round-md shadow">
                <van-row
                  type="flex"
                  align="center"
                  class="text-center"
                  style="justify-content: space-around"
                >
                  <div
                    v-for="(item, index) in menuList_other"
                    :span="item.span"
                    :key="index"
                  >
                    <van-col
                      @click="to(item)"
                      v-if="item.openDiasble"
                    >
                      <van-image
                        lazy-load
                        width="30"
                        :src="item.img"
                        class="full-width"
                      />
                      <div
                        class="font12 font-md"
                        style="line-height: 12px"
                      >
                        {{ item.title }}
                      </div>
                    </van-col>
                  </div>
                </van-row>
              </van-cell>
            </div>
          </div>
        </mescroll-vue>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Tabbar,
  TabbarItem,
  Popup,
  Grid,
  GridItem,
  Icon,
  NoticeBar,
  Image as VanImage,
  Cell,
  Swipe,
  SwipeItem, Toast,
} from 'vant'
import MescrollVue from 'mescroll.js/mescroll.vue'
import { getTimeState } from 'Utils/dateUtil'
import SchedulePanel from 'Views/Home/schedule/components/panel'
import ldStatusbar from 'Common/ldStatusbar'

import menu_tk from 'Components/Dynamic/default/images/menu/tk.png'
import menu_ht from 'Components/Dynamic/default/images/menu/ht.png'
import menu_tr from 'Components/Dynamic/default/images/menu/tr.png'
import menu_car from 'Components/Dynamic/default/images/menu/car.png'
import menu_visa from 'Components/Dynamic/default/images/menu/visa.png'

import menu_checkIn from 'Components/Dynamic/default/images/menu/checkIn.png'
import menu_fastCheck from 'Components/Dynamic/default/images/menu/fastCheck.png'
import menu_guestPass from 'Components/Dynamic/default/images/menu/guestPass.png'
import menu_restRoom from 'Components/Dynamic/default/images/menu/restRoom.png'

import menu_strategy from 'Assets/images/home/menu_strategy.png'
import menu_discount from 'Assets/images/home/menu_discount.png'
import menu_freebus from 'Assets/images/home/menu_freebus.png'
import menu_contracthotel from 'Assets/images/home/menu_contracthotel.png'
import menu_policy from 'Assets/images/home/menu_policy.png'

import bullhorn_icon from 'Components/Dynamic/default/images/home/bullhorn.png'
import homeMixin from './homeMixin'
import thirdLogin from '@/business/mixins/thirdLogin';
import tripType from 'Common/tripType/index.vue';
import { isGat } from 'Utils/gattools';
import { addBackFunc, removeBackFunc } from 'Utils/back';
import { isDjkk } from "Utils/djkktools";
import {waitForAuth} from "Utils/tools";

export default {
  name: 'Home',
  mixins: [homeMixin],
  props: {
    menulist: {
      type: Array,
      default: function () {
        return []
      },
    },
  },
  components: {
    tripType,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Popup.name]: Popup,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
    [VanImage.name]: VanImage,
    [Cell.name]: Cell,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    MescrollVue,
    ldStatusbar,
    SchedulePanel,
  },
  data () {
    return {
      modular: true,
      bullhorn_icon,
      menuList: [
        {
          link: '/tk/tkQuery',
          title: 'A008', //机票
          img: menu_tk,
          label: '低价机票，舒适出行',
          PRO_TYPE: 10901,
          openDiasble: false
        },
        {
          link: '/ht/htQuery',
          title: 'A009', //酒店
          img: menu_ht,
          label: '尊贵入住，商旅独享',
          PRO_TYPE: 10903,
          openDiasble: false

        },
        {
          link: '/tr/trQuery',
          title: 'A010', //火车票
          img: menu_tr,
          label: '舒适高铁，在线选座',
          PRO_TYPE: 10904,
          openDiasble: false

        },
        {
          link: '/car/carQuery',
          title: 'A011', //用车
          img: menu_car,
          label: '晚点必等，安心出行',
          PRO_TYPE: 10906,
          openDiasble: false

        },
      ],
      menuList_minor: [
        {
          link: '/tkIntel/policy',
          title: 'A019', //'国际特惠',
          img: menu_strategy,
          openDiasble: false

        },
        {
          link: '/tk/policy',
          title: 'A020', //'协议直减',
          img: menu_discount,
          openDiasble: false

        },
        {
          link: '/tk/airportBus',
          title: 'Q016', //机场大巴
          img: menu_freebus,
          openDiasble: false

        },
        {
          link: '/ht/htQuery/htSignList',
          title: 'A021', //'协议酒店',
          img: menu_contracthotel,
          openDiasble: false

        },
        {
          link: '/tk/strategy',
          title: 'Q007', //机场攻略
          img: menu_policy,
          openDiasble: false

        },
      ],
      menuList_other: [
        {
          link: '/visa',
          title: '签证', //签证
          img: menu_visa,
          label: '全国受理，一对一辅导',
          span: 4,
          PRO_TYPE: 10913,
          openDiasble: false

        },
        {
          link: '/checkIn',
          title: '优先值机',
          img: menu_checkIn,
          span: 5,
          PRO_TYPE: 10916,
          openDiasble: false

        },
        {
          link: '/guestPass',
          title: '要客通',
          img: menu_guestPass,
          span: 5,
          PRO_TYPE: 10917,
          openDiasble: false

        },
        {
          link: '/fastCheck',
          title: '快速安检',
          img: menu_fastCheck,
          span: 5,
          PRO_TYPE: 10915,
          openDiasble: false

        },
        {
          link: '/restRoom',
          title: '休息室',
          img: menu_restRoom,
          span: 5,
          PRO_TYPE: 10914,
          openDiasble: false

        },
        // {
        // 	link: '/home',
        // 	title: '敬请期待',
        // 	icon: 'iconweibiaoti-24',
        // 	color:'#248aff',
        // 	disabled: true
        // }
      ],
      orderList: [],
      images: [],
      isBrowserBack: false,
      routePath: '',
      showLogonDialog: true,
    }
  },
  async created () {
    addBackFunc(this.onBrowserBack);
    // 三方授权登录
    // await this.auth();
    await waitForAuth(3000);
    this.getLoginNotice(0) //获取登录公告
    this.getBadgeCount()
    this.checkOpenId()
    if (this.menulist.length) {
      this.menuList = this.menulist
    }
    await this.getAuthorizationPnos()
    // this.init()
    this.queryVipParameternavbar() //获取导航栏需要的操作
    this.genMenu([...this.menuList])
    this.genMenu([...this.menuList_other])
  },
  beforeDestroy() {
    removeBackFunc(this.onBrowserBack);
  },
  mounted () {
    this.getOrderList()
    this.getPullData()
    this.genMenu([...this.menuList])
    this.genMenu([...this.menuList_other])
  },
  computed: {
    menuListnew(){
      const OPEN_PRO_TYPES = this.authorizationPnosMap.map(i => Number(i.productNo))
      let obj= this.menuList.filter((menu)=>menu.PRO_TYPE && OPEN_PRO_TYPES.includes(menu.PRO_TYPE) )
      return obj
    },
    modularnew(){
      let newA = this.menuList_other.filter(function (item, index) { //index是索引
        return item.openDiasble == true
      })
      if (newA != '') {
        return true
      } else {
        return false
      }
    }

  },
  beforeRouteLeave (to, from, next) {
    if (!isGat()) {
      next()
    }
    if (this.isBrowserBack && this.routePath === '/home') {
      console.log('beforeRouteLeave', this.$route.path);
      this.isBrowserBack = false;

      for (let i = 0; i < history.length; i++) {
        console.log('history', i);
        history.back();
        this.$router.back();
      }

      next(false);
    } else {
      next()
    }
  },
  methods: {
    isDjkk,
    isGat,
    // init () {
    //   let newA = this.menuList_other.filter(function (item, index) { //index是索引
    //     return item.openDiasble == true
    //   })
    //   if (newA != '') {
    //     this.modular = true
    //   } else {
    //     this.modular = false
    //   }
    // },
    getTimeState,
    getPullData () {
      let data = {
        requestFrom: 2,
      }
      this.$api['common/pullData'](data).then((res) => {
        if (res.data) {
          const { data } = res
          let pictureUrlList = []
          data.forEach((element) => {
            let advertise = {
              pictureUrl: element.pictureUrl,
              advertiseLink: element.advertiseLink,
            }
            pictureUrlList.push(advertise)
          })
          this.images = pictureUrlList
        }
      })
    },
    goAdvertiseLink (path) {
      if (path) {
        location.href = path
      }
    },
    getOrderList () {
      this.$api['tkOrder/getScheduleOrder']()
        .then((res) => {
          var cache = res.data || {}
          this.orderList = cache.list || []
          if (this.orderList.length === 0) {
            this.getAdv()
          }
        })
        .catch(() => { })
    },
    // 获取广告图
    getAdv () { },
    back() {
      if (isGat()) {
        window.close();
      }
      if (isDjkk()) {
        if (!window.SmartCity) {
          console.error('SmartCity SDK 未加载')
          Toast.fail({duration: 5000, message: '缺失必要引用，操作失败'});
          return;
        }
        console.log('djkk.back.SmartCity：', window.SmartCity);
        if (!window.SmartCity.isSmartCityApp()) {
          console.error("SmartCity App 中打开此功能");
          Toast.fail({duration: 5000, message: '缺失必要环境，操作失败'});
          return;
        }
        window.SmartCity.goRoot();
        console.log('执行完大江看看APP-JS-SDK返回首页')
      }
    },
    // 浏览器回退事件,先于路由钩子之前执行
    onBrowserBack(e) {
      if (isGat()) {
        console.log('onBrowserBack', this.$route.path);
        this.routePath = this.$route.path;
        this.isBrowserBack = true;
      }
    },
  },
}
</script>

<style lang="less" scoped>
@deep: ~">>>";

.pointerEvents {
  pointer-events: auto;
}

.box {
  padding: 0 10px;
}

.home1 {
  //   position: relative;
  //   padding: 10px;
  //   background-size: cover;
  //   background-position-y: initial;

  .logo {
    img {
      width: 57px;
    }
  }

  .list {
    padding-bottom: 8px;
  }

  .container {
    padding: 4px;
  }

  .defaulthomewrapper {
    height: calc(100vh - 156px);
    overflow: hidden;
  }

  .vanSwipe {
    width: calc(100vw - 20px);
    height: 115px;
  }

  .shadow {
    box-shadow: 0 3px 3px 1px rgba(0, 0, 0, 8%);
  }
}

@{deep}.van-swipe__indicators {
  bottom: 7px;
}

@{deep}.van-swipe__indicator:not(.van-swipe__indicator--active) {
  border: 1px solid;
}

.default-banner {
  background-image: url("~Components/Dynamic/default/images/bg.png");
}

// 龙旅专属客服, 包车客服
.longLv-icon{
  font-size: 26px;
}
.longLv-text{
  font-size: 14px;
}
</style>
